exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign-success[data-v-31acc939]{text-align:center;padding-bottom:.4rem}.sign-success img[data-v-31acc939]{width:1.6rem;margin-bottom:.4rem}.sign-success .sign-success_title[data-v-31acc939]{color:#000;font-size:.32rem;line-height:.4rem;font-weight:bold}.sign-success .sign-success_tip[data-v-31acc939]{color:#b4b4b4;font-size:.18rem;margin-top:.12rem}.addbtn[data-v-31acc939]{text-align:center}.closebtn[data-v-31acc939]{text-align:center}", ""]);

// exports
